import { Button, UIHeading2, UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { TOfferFromHistoryData } from 'shared/store/offerHistory';

import * as styles from './styles.css';

interface IHideOfferModalProps {
  offer: TOfferFromHistoryData;
  onSuccess: () => void;
  onReject: () => void;
}

export const HideOfferModal: React.FC<React.PropsWithChildren<IHideOfferModalProps>> = ({
  offer,
  onSuccess,
  onReject,
}) => {
  return (
    <div>
      <div className={styles['text-row']}>
        <UIHeading2>{offer.prices.price}</UIHeading2>
      </div>

      <div className={styles['text-row']}>
        <UIHeading4>{offer.title}</UIHeading4>
        <UIText2>{offer.address}</UIText2>
      </div>

      {offer.kpName && <UIHeading4>{offer.kpName}</UIHeading4>}

      <div className={styles['buttons']}>
        <Button size="XS" theme="fill_success_secondary" onClick={onSuccess}>
          Скрыть
        </Button>
        <Button size="XS" theme="fill_error_secondary" onClick={onReject}>
          Отменить
        </Button>
      </div>
    </div>
  );
};
